// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useAuth, AuthProvider } from "./hooks/useAuth";
import { useRol } from "./hooks/useRoles";

import Sidebar      from "./components/Sidebar";
import TopBar       from "./components/TopBar";
import { useNotificaciones } from "./hooks/useNotificaciones";
import { useCotizaciones }   from "./hooks/useCotizaciones";
import Login        from "./pages/Login";
import Dashboard    from "./pages/Dashboard";
import Clientes     from "./pages/Clientes";
import NuevoCliente from "./pages/NuevoCliente";
import Seguimiento  from "./pages/Seguimiento";
import Pipeline     from "./pages/Pipeline";
import Pedidos      from "./pages/Pedidos";
import Proveedores  from "./pages/Proveedores";
import Transporte   from "./pages/Transporte";
import Usuarios      from "./pages/Usuarios";
import Reportes      from "./pages/Reportes";
import Cotizaciones  from "./pages/Cotizaciones";
import PerfilCliente from "./pages/PerfilCliente";
import MiDia        from "./pages/MiDia";
import Reuniones           from "./pages/Reuniones";
import PipelineCotizacion  from "./pages/PipelineCotizacion";
import Monitoreo           from "./pages/Monitoreo";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{
      height: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#3A3C7A",
    }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ color: "#F97316", fontSize: 15, fontWeight: 700, marginTop: 8 }}>PROVEXO+</div>
        <div style={{ color: "#c7d2fe", fontSize: 12, marginTop: 4 }}>Cargando sistema...</div>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

function RolRoute({ children, permiso }) {
  const { permisos, loading } = useRol();
  if (loading) return null;
  if (permiso && !permisos[permiso]) return (
    <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", fontSize: 14 }}>
      No tienes permiso para ver esta sección.
    </div>
  );
  return children;
}

function NotifWrapper() {
  const { cotizaciones } = useCotizaciones();
  useNotificaciones(cotizaciones);
  return null;
}

function Layout() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar isMobile={isMobile} />
      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        background: "#f8fafc",
        minWidth: 0,
        overflow: "hidden",
      }}>
        {!isMobile && <TopBar />}
        <main className="page-enter" style={{
          flex: 1,
          overflowY: "auto",
          padding: "24px",
        }}>
          <NotifWrapper />
          <Routes>
            <Route path="/"                    element={<Dashboard />} />
            <Route path="/midia"               element={<MiDia />} />
            <Route path="/clientes"            element={<Clientes />} />
            <Route path="/cotizaciones"        element={<Cotizaciones />} />
            <Route path="/clientes/nuevo"      element={<NuevoCliente />} />
            <Route path="/clientes/:id"        element={<NuevoCliente editMode />} />
            <Route path="/clientes/:id/perfil" element={<PerfilCliente />} />
            <Route path="/pedidos"        element={<Pedidos />} />
            <Route path="/transporte"     element={<Transporte />} />
            <Route path="/seguimiento"    element={<Seguimiento />} />
            <Route path="/reuniones"      element={<Reuniones />} />
            <Route path="/pipeline"          element={<Pipeline />} />
            <Route path="/cotizacion-nueva" element={<PipelineCotizacion />} />
            <Route path="/monitoreo"         element={
              <RolRoute permiso="verMonitoreo"><Monitoreo /></RolRoute>
            } />
            <Route path="/proveedores"    element={
              <RolRoute permiso="verProveedores"><Proveedores /></RolRoute>
            } /> 
            <Route path="/reportes" element={
              <RolRoute permiso="verReportes"><Reportes /></RolRoute>
            } />
            <Route path="/usuarios"       element={
              <RolRoute permiso="verUsuarios"><Usuarios /></RolRoute>
            } />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 4000, style: { fontSize: 13 } }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*"     element={<ProtectedRoute><Layout /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}